import { API_ENDPOINTS } from '../api/config';

let cachedPricingPlans = null;
let pricingPlansPromise = null;

export const splitPricingPlans = (plansData) => {
  const regularPlansData = {};
  const aiPlansData = {};

  Object.keys(plansData || {}).forEach((planKey) => {
    if (planKey.startsWith('ai_')) {
      aiPlansData[planKey] = plansData[planKey];
    } else {
      regularPlansData[planKey] = plansData[planKey];
    }
  });

  return { regularPlansData, aiPlansData };
};

export const getPricingPlans = async () => {
  if (cachedPricingPlans) {
    return cachedPricingPlans;
  }

  if (pricingPlansPromise) {
    return pricingPlansPromise;
  }

  pricingPlansPromise = (async () => {
    const response = await fetch(API_ENDPOINTS.SUBSCRIPTION_PLANS, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch pricing plans: ${response.status}`);
    }

    const plansData = await response.json();
    cachedPricingPlans = plansData;
    return plansData;
  })()
    .catch((error) => {
      cachedPricingPlans = null;
      throw error;
    })
    .finally(() => {
      pricingPlansPromise = null;
    });

  return pricingPlansPromise;
};

export const prefetchPricingPlans = () => {
  void getPricingPlans().catch(() => {
    // Intentionally ignore prefetch failures so the UI can fall back to
    // its existing default pricing copy.
  });
};
